import React from 'react';
import { Box } from '@mui/material';
import { ConversationDetails } from 'modules/conversations/components/ConversationDetails';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  conversationId: string;
  jobTitle: string;
  location: string;
  moveToConversation: (direction: 'next' | 'previous') => void;
  conversationsCount: number;
  conversationIndex: number;
};

export { type Props as ConversationDetailsProps };

export const ConversationDetailsDrawer: React.FC<Props> = (props) => {
  const { conversationId, ...headerItems } = props;

  return (
    <Box
      sx={{
        height: '100%',
        maxHeight: '100vh'
      }}
    >
      <ConversationDetails
        conversationId={conversationId}
        headerItems={headerItems}
      />
    </Box>
  );
};
